import { ThunkType } from "../../../../core/store/reducers";
import { setorderInd, invalidateorderInd } from "../orderIndDataReducer";
import { setIndex } from "../orderIndUXSlice";
import getAllOrderIndApi from "../api/getAllOrderInd";
import { PageIndex, PageDataStatus } from "../../../models";

export const loadAllOrderInd = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  const { pageNumber, itemsPerPage } = store.ux.trading.orderInd.index;
  const filter = store.ux.trading.orderInd.filter;
  const user = store.data.auth.current.user;

  const orderIndResponse = await dispatch(
    getAllOrderIndApi(user, pageNumber, itemsPerPage, filter)
  );

  if (!orderIndResponse || orderIndResponse.resCode !== "OK") {
    return;
  }

  const orderInd = {
    currentPageData: orderIndResponse.obj,
    totalCount: Number(orderIndResponse.resDesc) || 0,
    status: PageDataStatus.DataCurrent,
  };

  dispatch(setorderInd(orderInd));
};

export const setOrderIndIndexThunk = (index: PageIndex): ThunkType => (
	dispatch
) => {
	dispatch(setIndex(index));
	dispatch(invalidateorderInd());
	dispatch(loadAllOrderInd());
};